module.exports = __webpack_public_path__ + "static/media/logo_idb_secundair.53439b03.svg";